export default __webpack_public_path__ + "fonts/worry-img4.svg";